// extracted by mini-css-extract-plugin
export var container = "errors-module__container___IPwID";
export var error = "errors-module__error___aagHY";
export var header = "errors-module__header___CHqnd";
export var textContainer = "errors-module__textContainer___H_QWD";
export var text = "errors-module__text___vR10G";
export var buttonContainer = "errors-module__buttonContainer___BGq9U";